import { AbilityBuilder, Ability } from '@casl/ability'

export const ability = new Ability(rulesForUser())

export function updateAbilityWithRole (user) {
  let role = ''
  if (user) {
    role = user.role
  }
  ability.update(rulesForUser(role))
  return ability
}

function rulesForUser (userRole) {
  return AbilityBuilder.define((allow, forbid) => {
    function baseRights () {
      allow('enterRoute', [
        'settings',
        'referrals',
        'help'
      ])
    }

    function employeeRights () {
      baseRights()
      allow('enterRoute', 'timetracking')
    }

    function userRights () {
      baseRights() // extends basic rights
      allow('enterRoute', [
        'employees',
        'company',
        'employee',
        'employeeSettings',
        'timesheet',
        'subscription'
      ])
    }

    function companyManagerRights () {
      baseRights() // extends basic rights
      allow('enterRoute', [
        'subscriptionSettings',
        'subscription',
        'company',
        'companyCreate',
        'employees',
        'employee',
        'employeeSettings',
        'timesheet',
        'timesheetBatchEdit',
        'employeeCreate',
        'invoices',
        'archives'
      ])
      allow('create', 'Employee')
      allow('create', 'Company')
      allow('edit', 'Company')
      allow('edit', 'Employee')
      allow('read', 'Timesheet')
      allow('download', 'Timesheet')
      allow('read', 'TimesheetSchema')
    }

    switch (userRole) {
      case 'user':
        userRights()
        break
      case 'employee':
        employeeRights()
        break
      case 'company_manager':
        companyManagerRights()
        break
    }
  }).rules
}
